import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import SignUpCard from '../../components/SignUp/SignUpCard'
import { resetAuthError, resetAuthSuccess, resetSession } from '../../redux/auth'
import { connect } from 'react-redux'
import { RootState } from '../../redux/rootReducers'
import { Loader } from '../../components/commons'

type AppProps={
  success:number|null;
message:string|null;
fetching:boolean;
error:string|null;
statusCode:number|null;
dispatchResetAuthError:()=> void;
dispatchResetAuthSuccess:()=> void;
dispatchResetSessionAction:()=> void;
}
const SignUp = ({
  success,
  message,
  fetching,
  error,
  statusCode,
  dispatchResetAuthError,
  dispatchResetAuthSuccess,
  dispatchResetSessionAction
}:AppProps) => {

    useEffect(() => {
      dispatchResetAuthError();
      dispatchResetAuthSuccess();

 // Add GTM script here
 const script = document.createElement('script');
 script.innerHTML = `
   (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
   new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
   j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
   'https://www.googletagmanager.com/gtm.js?id=GTM-TNQG5XP'+dl;f.parentNode.insertBefore(j,f);
   })(window,document,'script','dataLayer','GTM-TNQG5XP');
 `;
 document.body.appendChild(script);

 // Add noscript iframe
 const noscript = document.createElement('noscript');
 noscript.innerHTML = `
   <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-TNQG5XP"
     height="0" width="0" style="display:none;visibility:hidden"></iframe>
 `;
 document.body.appendChild(noscript);

 return () => {
   // Clean up the added scripts
   document.body.removeChild(script);
   document.body.removeChild(noscript);
 };

    }, []);

  return (
    <div>
       <Helmet>
        <title>FINAC by Akssai ProjExel</title>
      </Helmet>
      <>
       
      </>
      <SignUpCard/>
     
      {fetching && <Loader />}
    </div>
  )
}

const mapStateToProps = (state: RootState) => ({
  success: state.auth.success,
  message: state.auth.message,
  fetching: state.auth.fetching,
  error: state.auth.error,
  statusCode: state.auth.statusCode,
 
});

const mapDispatchToProps = (dispatch: any) => ({
  
  dispatchResetAuthError: () => dispatch(resetAuthError()),

  dispatchResetAuthSuccess: () => dispatch(resetAuthSuccess()),
  dispatchResetSessionAction: () => dispatch(resetSession()),

});


export default connect(mapStateToProps, mapDispatchToProps)(SignUp);

